// extracted by mini-css-extract-plugin
export default {"main":"SignUp_main__hIo28","cta-form":"SignUp_cta-form__S4+aU","btn--form":"SignUp_btn--form__VR559"};